import { composeIO } from 'react-compose-io'
import { appMenuItemIO } from './AppMenuItem.IO'
import AppMenuItemView from './AppMenuItem.View'

export const AppMenuItem = composeIO(AppMenuItemView, appMenuItemIO)
